// extracted by mini-css-extract-plugin
export default {"root":"ClassesScheduleSelect_root__KQfRb"};